/**
 * @desc 修改周计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanWeekUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/week/updatePlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanWeekUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/week/updatePlanInfo',
    data,
  });
}
